import {
  Button,
  Divider,
  Typography,
  Grid,
  TextField,
  InputLabel,
  FormControl,
  // Select,
  // MenuItem,
  Switch,
} from "@common-ui/ui";
import { DeleteForever, AddCircle } from "@mui/icons-material";
import React from "react";
import { useDispatch } from "react-redux";
import { workInstructionSlice } from "../../../../reducers/workReducer";

const PassFail = ({
  subSection,
  sectionIndex,
  subSectionIndex,
  handleRemoveSubSection,
  steps,
}) => {
  const dispatch = useDispatch();
  const AddAnother = () => {
    dispatch(
      workInstructionSlice.actions.addTestPoint({
        sectionIndex,
        subSectionIndex,
        name: subSection?.name,
        type: subSection?.name.toLocaleUpperCase(),
      })
    );
  };
  const handleDeleteTestPoint = (id) => {
    dispatch(
      workInstructionSlice.actions.deleteTestPoint({
        sectionIndex,
        subSectionIndex,
        name: subSection?.name,
        id,
      })
    );
  };
  const handleChange = (e, id) => {
    const { name, value } = e.target;
    if (name === "na" || "warn") {
      return dispatch(
        workInstructionSlice.actions.updateTestPoint({
          sectionIndex,
          subSectionIndex,
          id,
          testPointName: name,
          value: e.target.checked,
        })
      );
    }
    dispatch(
      workInstructionSlice.actions.updateTestPoint({
        sectionIndex,
        subSectionIndex,
        id,
        testPointName: name,
        value,
      })
    );
  };

  return (
    <div>
      <span style={{ display: "flex", alignItems: "center" }}>
        {/* <Typography sx={{ mr: 1 }}>
          {`${sectionIndex + 1}.${subSectionIndex + 1}`}
        </Typography> */}
        {/* <Typography sx={{ mr: 1 }} variant="h4">
          {subSection?.name}
        </Typography> */}

        <Button
          onClick={() => handleRemoveSubSection(subSection.id)}
          startIcon={<DeleteForever />}
          size="small"
          sx={{ fontWeight: 200 }}
        >
          Remove
        </Button>
      </span>
      {/* <div>
        <InputLabel>Title</InputLabel>
        <TextField
          sx={{ mt: 1 }}
          size="small"
          fullWidth
          placeholder="Type"
          margin="normal"
          name="content"
          value={subSection.title}
          onChange={(e) =>
            dispatch(
              workInstructionSlice.actions.updateSubSections({
                sectionIndex,
                subSectionIndex,
                name: "title",
                value: e.target.value,
              })
            )
          }
        />
      </div> */}
      <Divider sx={{ my: 2 }} />
      {/* Headers */}
      <Grid container spacing={1}>
        <Grid item md={1} xs={12}>
          <div>
            <InputLabel>Step</InputLabel>
          </div>
        </Grid>
        <Grid item md={3} xs={12}>
          <div>
            <InputLabel>Label</InputLabel>
          </div>
        </Grid>
        <Grid item md={3} xs={12}>
          <div>
            <InputLabel>Description</InputLabel>
          </div>
        </Grid>
        {/* <Grid item md={2.75} xs={12}>
          <div>
            <InputLabel>Test Types</InputLabel>
          </div>
        </Grid> */}
        <Grid item md={1} xs={12}>
          <div>
            <InputLabel>N/A?</InputLabel>
          </div>
        </Grid>
        <Grid item md={1} xs={12}>
          <div>
            <InputLabel>Warn?</InputLabel>
          </div>
        </Grid>
        <Grid item md={1} xs={12}>
          <div>
            <InputLabel>Actions</InputLabel>
          </div>
        </Grid>
      </Grid>
      {/* Test Points */}
      {Array.from(subSection.test_points).map((item, index) => {
        let step = !subSection.subName
          ? steps.find((element) => element.id === item.id).step
          : `${
              steps.find((element) => element.id === subSection.id)[
                "nextSteps"
              ][index].step
            }`;
        return (
          <Grid key={item.id} container spacing={1}>
            <Grid item md={1} xs={12}>
              <div>
                <Typography sx={{ mt: { md: 2.5 } }}>
                  {`${sectionIndex + 1}.
                  ${step}
                `}
                </Typography>
              </div>
            </Grid>
            <Grid item md={3} xs={12}>
              <div>
                <TextField
                  sx={{ mt: 1 }}
                  onChange={(e) => handleChange(e, item.id)}
                  size="small"
                  fullWidth
                  name="label"
                  value={item.label}
                  variant="outlined"
                  placeholder="Example: Self Test"
                />
              </div>
            </Grid>
            <Grid item md={3} xs={12}>
              <div>
                <TextField
                  sx={{ mt: 1 }}
                  onChange={(e) => handleChange(e, item.id)}
                  size="small"
                  fullWidth
                  placeholder="Example: Initiate instrument Self-Test"
                  name="description"
                  value={item.description}
                  variant="outlined"
                />
              </div>
            </Grid>
            <Grid item md={1} xs={12}>
              <div>
                <FormControl fullWidth name="na">
                  {/* <Select
                    sx={{ mt: 1 }}
                    onChange={(e) => handleChange(e, item.id)}
                    size="small"
                    placeholder="Select"
                    name="na"
                    variant="outlined"
                    value={item.na}
                    // displayEmpty
                    // renderValue={() => "Select"}
                  >
                    <MenuItem value="none" disabled>
                      <em>Select</em>
                    </MenuItem>
                    <MenuItem value={true}>Yes</MenuItem>
                    <MenuItem value={false}>No</MenuItem>
                  </Select> */}
                  <Switch
                    {...{ inputProps: { "aria-label": "Switch na" } }}
                    inputProps={{ "aria-label": "controlled" }}
                    sx={{ mt: 1 }}
                    onChange={(e) => handleChange(e, item.id)}
                    // size="small"
                    name="na"
                    checked={item.na === true}
                    // value={item.na}
                  />
                </FormControl>
              </div>
            </Grid>
            <Grid item md={1} xs={12}>
              <div>
                <FormControl fullWidth name="warn">
                  <Switch
                    {...{ inputProps: { "aria-label": "Switch warn" } }}
                    inputProps={{ "aria-label": "controlled" }}
                    sx={{ mt: 1 }}
                    onChange={(e) => handleChange(e, item.id)}
                    // size="small"
                    name="warn"
                    checked={item.warn === true}
                    // value={item.warn}
                  />
                </FormControl>
              </div>
            </Grid>
            <Grid item md={1} xs={12}>
              <div>
                <Button
                  startIcon={<DeleteForever />}
                  sx={{ fontWeight: 200, mt: { md: 1.5 } }}
                  size="small"
                  onClick={() => handleDeleteTestPoint(item.id)}
                >
                  Remove
                </Button>
              </div>
            </Grid>
          </Grid>
        );
      })}
      <Button
        startIcon={<AddCircle />}
        sx={{ fontWeight: 200, mt: 2 }}
        size="small"
        onClick={() => AddAnother()}
      >
        Add a Test Point
      </Button>
      <Divider sx={{ my: 2 }} />
    </div>
  );
};

export default PassFail;
